<template>
  <div class="quarters-range d-flex">
    <SelectDayMonth
      ref="startDate"
      v-model="startLocal"
      :before="endLocal"
      :current-year="currentYear"
      :next-year="nextYear"
      :open.sync="openStart"
      @on-change="
        (value) => {
          $emit('on-change', { type: 'start', value });
        }
      "
    />
    <span>-</span>
    <SelectDayMonth
      v-model="endLocal"
      :after="startLocal"
      :disable="disableEnd"
      :current-year="currentYear"
      :next-year="nextYear"
      :open.sync="openEnd"
      @on-change="
        (value) => {
          $emit('on-change', { type: 'end', value });
        }
      "
    />
  </div>
</template>

<script>
import SelectDayMonth from "./";

export default {
  name: "SelectDayMonthRange",

  components: {
    SelectDayMonth,
  },

  props: {
    value: {
      type: String,
      Array,
      required: false,
      default: "2020-1-1",
    },
    start: {
      type: String,
      required: false,
      default: "2020-1-1",
    },
    end: {
      type: String,
      required: false,
      default: "2020-7-1",
    },
    endNextYear: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableEnd: {
      type: Boolean,
      required: false,
      default: false,
    },
    before: {
      type: String,
      Array,
      required: false,
      default: "",
    },
    after: {
      type: String,
      Array,
      required: false,
      default: "",
    },
    currentYear: {
      type: Number,
      required: false,
      default: () => {
        return new Date().getFullYear();
      },
    },
    nextYear: {
      type: Number,
      required: false,
      default: () => {
        return new Date().getFullYear() + 1;
      },
    },
  },

  data: function () {
    return {
      openStart: false,
      openEnd: false,
    };
  },

  computed: {
    startLocal: {
      get() {
        return this.start;
      },
      set(newValue) {
        this.$emit("update:start", newValue);
      },
    },
    endLocal: {
      get() {
        return this.end;
      },
      set(newValue) {
        this.$emit("update:end", newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
